import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';

export default function Edit({ attributes, setAttributes }) {
    const { id_logo_1Url, id_logo_1Id, id_logo_1Alt, id_logo_1Opacite, id_logo_1Afficher, blocCouleurFond, blocCouleurBordure, blocImageFondUrl, blocImageFondId, animCode } = attributes;

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = blocImageFondUrl 
        ? { 
            backgroundImage: `url(${blocImageFondUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{``}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondUrl: media.url, blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {blocImageFondUrl ? (
                                        <div>
                                            <img src={blocImageFondUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondUrl: '', blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="logo-1 (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_logo_1Afficher}
                        onChange={(val) => setAttributes({ id_logo_1Afficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_logo_1Alt}
                            onChange={(val) => setAttributes({ id_logo_1Alt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_logo_1Opacite}
                        onChange={(val) => setAttributes({ id_logo_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                <div className="container-fluid" id="id_bloc">
                    {/* id_inner_border */}
                    <hr />
                    {/* end-id_inner_border */}
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-5">
                        <div className="col mb-3">
                            {/* id_logo_1 */}
                            <a href="attribut_id_logo_1_lien" className="d-flex align-items-center mb-3">
                                <img className="mx-auto mx-sm-0 d-block" src="attribut_id_logo_1_src" alt="attribut_id_logo_1_alt" />
                            </a>
                            {/* end-id_logo_1 */}
                        </div>
                        <div className="col mb-3 d-none d-sm-block"></div>
                        {/* id_colonne_liens_1 */}
                        <div className="col mb-3 d-none d-sm-block">
                            {/* id_colonne_liens_1_titre_colonne */}
                            <h5 id="id_colonne_liens_1_titre_colonne">
attribut_id_colonne_liens_1_titre_colonne_texte
                            </h5>
                            {/* end-id_colonne_liens_1_titre_colonne */}
                            <ul className="nav flex-column">
                                {/* id_colonne_liens_1_lien_colonne_1 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_1_lien_colonne_1_lien" id="id_colonne_liens_1_lien_colonne_1" className="nav-link p-0">
                                        <span id="id_colonne_liens_1_lien_colonne_1_texte">
attribut_id_colonne_liens_1_lien_colonne_1_texte_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_1_lien_colonne_1 */}
                                {/* id_colonne_liens_1_lien_colonne_2 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_1_lien_colonne_2_lien" id="id_colonne_liens_1_lien_colonne_2" className="nav-link p-0">
                                        <span id="id_colonne_liens_1_lien_colonne_2_texte">
attribut_id_colonne_liens_1_lien_colonne_2_texte_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_1_lien_colonne_2 */}
                                {/* id_colonne_liens_1_lien_colonne_3 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_1_lien_colonne_3_lien" id="id_colonne_liens_1_lien_colonne_3" className="nav-link p-0">
                                        <span id="id_colonne_liens_1_lien_colonne_3_texte">
attribut_id_colonne_liens_1_lien_colonne_3_texte_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_1_lien_colonne_3 */}
                                {/* id_colonne_liens_1_lien_colonne_4 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_1_lien_colonne_4_lien" id="id_colonne_liens_1_lien_colonne_4" className="nav-link p-0">
                                        <span id="id_colonne_liens_1_lien_colonne_4_texte">
attribut_id_colonne_liens_1_lien_colonne_4_texte_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_1_lien_colonne_4 */}
                                {/* id_colonne_liens_1_lien_surlignage_1 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_1_lien_surlignage_1_lien" id="id_colonne_liens_1_lien_surlignage_1" className="nav-link p-0">
attribut_id_colonne_liens_1_lien_surlignage_1_texte
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_1_lien_surlignage_1 */}
                                {/* id_colonne_liens_1_lien_surlignage_2 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_1_lien_surlignage_2_lien" id="id_colonne_liens_1_lien_surlignage_2" className="nav-link p-0">
attribut_id_colonne_liens_1_lien_surlignage_2_texte
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_1_lien_surlignage_2 */}
                                {/* id_colonne_liens_1_lien_surlignage_3 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_1_lien_surlignage_3_lien" id="id_colonne_liens_1_lien_surlignage_3" className="nav-link p-0">
attribut_id_colonne_liens_1_lien_surlignage_3_texte
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_1_lien_surlignage_3 */}
                                {/* id_colonne_liens_1_lien_surlignage_4 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_1_lien_surlignage_4_lien" id="id_colonne_liens_1_lien_surlignage_4" className="nav-link p-0">
attribut_id_colonne_liens_1_lien_surlignage_4_texte
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_1_lien_surlignage_4 */}
                                {/* id_colonne_liens_1_lien_surlignage_5 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_1_lien_surlignage_5_lien" id="id_colonne_liens_1_lien_surlignage_5" className="nav-link p-0">
                                        <span id="id_colonne_liens_1_lien_surlignage_5_lien">
attribut_id_colonne_liens_1_lien_surlignage_5_lien_texte
                                        </span>
                                        <span id="id_colonne_liens_1_lien_surlignage_5_lien_1">
attribut_id_colonne_liens_1_lien_surlignage_5_lien_1_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_1_lien_surlignage_5 */}
                            </ul>
                        </div>
                        {/* end-id_colonne_liens_1 */}
                        {/* id_colonne_liens_2 */}
                        <div className="col mb-3 d-none d-sm-block">
                            {/* id_colonne_liens_2_titre_colonne */}
                            <h5 id="id_colonne_liens_2_titre_colonne">
attribut_id_colonne_liens_2_titre_colonne_texte
                            </h5>
                            {/* end-id_colonne_liens_2_titre_colonne */}
                            <ul className="nav flex-column">
                                {/* id_colonne_liens_2_lien_colonne_1 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_2_lien_colonne_1_lien" id="id_colonne_liens_2_lien_colonne_1" className="nav-link p-0">
                                        <span id="id_colonne_liens_2_lien_colonne_1_texte">
attribut_id_colonne_liens_2_lien_colonne_1_texte_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_2_lien_colonne_1 */}
                                {/* id_colonne_liens_2_lien_colonne_2 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_2_lien_colonne_2_lien" id="id_colonne_liens_2_lien_colonne_2" className="nav-link p-0">
                                        <span id="id_colonne_liens_2_lien_colonne_2_texte">
attribut_id_colonne_liens_2_lien_colonne_2_texte_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_2_lien_colonne_2 */}
                                {/* id_colonne_liens_2_lien_colonne_3 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_2_lien_colonne_3_lien" id="id_colonne_liens_2_lien_colonne_3" className="nav-link p-0">
                                        <span id="id_colonne_liens_2_lien_colonne_3_texte">
attribut_id_colonne_liens_2_lien_colonne_3_texte_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_2_lien_colonne_3 */}
                                {/* id_colonne_liens_2_lien_colonne_4 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_2_lien_colonne_4_lien" id="id_colonne_liens_2_lien_colonne_4" className="nav-link p-0">
                                        <span id="id_colonne_liens_2_lien_colonne_4_texte">
attribut_id_colonne_liens_2_lien_colonne_4_texte_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_2_lien_colonne_4 */}
                                {/* id_colonne_liens_2_lien_surlignage_1 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_2_lien_surlignage_1_lien" id="id_colonne_liens_2_lien_surlignage_1" className="nav-link p-0">
attribut_id_colonne_liens_2_lien_surlignage_1_texte
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_2_lien_surlignage_1 */}
                                {/* id_colonne_liens_2_lien_surlignage_2 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_2_lien_surlignage_2_lien" id="id_colonne_liens_2_lien_surlignage_2" className="nav-link p-0">
attribut_id_colonne_liens_2_lien_surlignage_2_texte
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_2_lien_surlignage_2 */}
                                {/* id_colonne_liens_2_lien_surlignage_3 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_2_lien_surlignage_3_lien" id="id_colonne_liens_2_lien_surlignage_3" className="nav-link p-0">
attribut_id_colonne_liens_2_lien_surlignage_3_texte
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_2_lien_surlignage_3 */}
                                {/* id_colonne_liens_2_lien_surlignage_4 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_2_lien_surlignage_4_lien" id="id_colonne_liens_2_lien_surlignage_4" className="nav-link p-0">
                                        <span id="id_colonne_liens_2_lien_surlignage_4_lien">
attribut_id_colonne_liens_2_lien_surlignage_4_lien_texte
                                        </span>
                                        <span id="id_colonne_liens_2_lien_surlignage_4_lien_1">
attribut_id_colonne_liens_2_lien_surlignage_4_lien_1_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_2_lien_surlignage_4 */}
                                {/* id_colonne_liens_2_lien_surlignage_5 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_2_lien_surlignage_5_lien" id="id_colonne_liens_2_lien_surlignage_5" className="nav-link p-0">
                                        <span id="id_colonne_liens_2_lien_surlignage_5_lien">
attribut_id_colonne_liens_2_lien_surlignage_5_lien_texte
                                        </span>
                                        <span id="id_colonne_liens_2_lien_surlignage_5_lien_1">
attribut_id_colonne_liens_2_lien_surlignage_5_lien_1_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_2_lien_surlignage_5 */}
                            </ul>
                        </div>
                        {/* end-id_colonne_liens_2 */}
                        {/* id_colonne_liens_3 */}
                        <div className="col mb-3 d-none d-sm-block">
                            {/* id_colonne_liens_3_titre_colonne */}
                            <h5 id="id_colonne_liens_3_titre_colonne">
attribut_id_colonne_liens_3_titre_colonne_texte
                            </h5>
                            {/* end-id_colonne_liens_3_titre_colonne */}
                            <ul className="nav flex-column">
                                {/* id_colonne_liens_3_lien_colonne_1 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_3_lien_colonne_1_lien" id="id_colonne_liens_3_lien_colonne_1" className="nav-link p-0">
                                        <span id="id_colonne_liens_3_lien_colonne_1_texte">
attribut_id_colonne_liens_3_lien_colonne_1_texte_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_3_lien_colonne_1 */}
                                {/* id_colonne_liens_3_lien_colonne_2 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_3_lien_colonne_2_lien" id="id_colonne_liens_3_lien_colonne_2" className="nav-link p-0">
                                        <span id="id_colonne_liens_3_lien_colonne_2_texte">
attribut_id_colonne_liens_3_lien_colonne_2_texte_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_3_lien_colonne_2 */}
                                {/* id_colonne_liens_3_lien_colonne_3 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_3_lien_colonne_3_lien" id="id_colonne_liens_3_lien_colonne_3" className="nav-link p-0">
                                        <span id="id_colonne_liens_3_lien_colonne_3_texte">
attribut_id_colonne_liens_3_lien_colonne_3_texte_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_3_lien_colonne_3 */}
                                {/* id_colonne_liens_3_lien_colonne_4 */}
                                <li className="nav-item mb-2">
                                    <a href="attribut_id_colonne_liens_3_lien_colonne_4_lien" id="id_colonne_liens_3_lien_colonne_4" className="nav-link p-0">
                                        <span id="id_colonne_liens_3_lien_colonne_4_texte">
attribut_id_colonne_liens_3_lien_colonne_4_texte_texte
                                        </span>
                                    </a>
                                </li>
                                {/* end-id_colonne_liens_3_lien_colonne_4 */}
                            </ul>
                        </div>
                        {/* end-id_colonne_liens_3 */}
                    </div>
                    {/* id_signature_sds */}
                    <div className="row text-center my-5">
                        {/* id_signature_sds_coeur */}
                        <img id="id_signature_sds_coeur" src="attribut_id_signature_sds_coeur_src" alt="attribut_id_signature_sds_coeur_alt" className="d-inline-block" style="width: 20px; height: 20px;" />
                        {/* end-id_signature_sds_coeur */}
                        {/* id_signature_sds_signature_text */}
                        <p id="id_signature_sds_signature_text" className="d-inline">
attribut_id_signature_sds_signature_text_texte
                        </p>
                        {/* end-id_signature_sds_signature_text */}
                    </div>
                    {/* end-id_signature_sds */}
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}